import React, { useState, useEffect } from 'react';
import axios from 'axios';
import SearchableSelect from './SearchableSelect';

function VendorSelect({ value, onChange, required = false, placeholder = "Select Vendor" }) {
  const [vendors, setVendors] = useState([]);

  useEffect(() => {
    fetchVendors();
  }, []);

  const fetchVendors = async () => {
    try {
      const response = await axios.get('/api/vendors');
      setVendors(response.data);
    } catch (error) {
      console.error('Error fetching vendors:', error);
    }
  };

  const handleQuickAdd = async (name) => {
    try {
      const response = await axios.post('/api/vendors', {
        name: name,
        contactPerson: '',
        phone: '',
        email: '',
        address: ''
      });
      await fetchVendors();
      return { value: response.data.id, label: response.data.name };
    } catch (error) {
      console.error('Error adding vendor:', error);
      throw error;
    }
  };

  const options = vendors.map(vendor => ({
    value: vendor.id,
    label: vendor.name
  }));

  return (
    <SearchableSelect
      options={options}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required={required}
      onQuickAdd={handleQuickAdd}
      addButtonText="Add Vendor"
    />
  );
}

export default VendorSelect;